import { DEFAULT_BOARD_TIMELINE } from '../../app.constants';
import { BoardTimeline } from '../../model/board-timeline';

type BoardTimelineDeprecated = {
  boardStart: number;
  timelineStart: number;
  timelineEnd: number;
};

type BoardTimelineSomeOptional = {
  boardStartYear: number;
  activityBasedInventoryStartYear?: number;
  scenarioStartYear: number;
  latestFinalisedInventoryYear?: number;
  boardEndYear: number;
};

const isBoardTimeline = (timeline: any): timeline is BoardTimelineSomeOptional | BoardTimeline =>
  'boardStartYear' in timeline;
const isBoardTimelineDeprecated = (timeline: any): timeline is BoardTimelineDeprecated => 'boardStart' in timeline;

export function timelineV1ToTimelineV2(
  timeline: BoardTimeline | BoardTimelineSomeOptional | BoardTimelineDeprecated | undefined
): BoardTimeline {
  if (!timeline) {
    return DEFAULT_BOARD_TIMELINE;
  }

  if (isBoardTimeline(timeline)) {
    const boardStartYear = timeline.boardStartYear || timeline.scenarioStartYear;
    let scenarioStartYear = timeline.scenarioStartYear || timeline.boardStartYear;
    let boardEndYear = timeline.boardEndYear || timeline.scenarioStartYear || timeline.boardStartYear;

    if (scenarioStartYear < boardStartYear) {
      scenarioStartYear = boardStartYear;
    }
    if (boardEndYear < scenarioStartYear) {
      boardEndYear = scenarioStartYear;
    }
    const activityBasedInventoryStartYear = timeline.activityBasedInventoryStartYear || scenarioStartYear;
    const latestFinalisedInventoryYear = timeline.latestFinalisedInventoryYear || scenarioStartYear;

    return {
      boardStartYear,
      activityBasedInventoryStartYear,
      scenarioStartYear,
      latestFinalisedInventoryYear,
      boardEndYear,
    };
  }

  if (isBoardTimelineDeprecated(timeline)) {
    const boardStartYear = timeline.boardStart || timeline.timelineStart;
    let scenarioStartYear = timeline.timelineStart || timeline.boardStart;
    let boardEndYear = timeline.timelineEnd || timeline.timelineStart || timeline.boardStart;

    if (scenarioStartYear < boardStartYear) {
      scenarioStartYear = boardStartYear;
    }
    if (boardEndYear < scenarioStartYear) {
      boardEndYear = scenarioStartYear;
    }

    const activityBasedInventoryStartYear = scenarioStartYear;
    const latestFinalisedInventoryYear = scenarioStartYear;

    return {
      boardStartYear,
      activityBasedInventoryStartYear,
      scenarioStartYear,
      latestFinalisedInventoryYear,
      boardEndYear,
    };
  }

  return timeline;
}
